import { HARDWARE_SOURCE_CONFIGS_STR } from "src/utils/ReplacementConstant";

export interface HardwareSourceConfig {
    sensorTypes: string[],
    supportIncompleteCapture: boolean,
    supportPCDImageViewing: boolean,
    supportedRegions: string[]
}

export const HARDWARE_SOURCE_CONFIGS: Map<string, HardwareSourceConfig> = getHardwareSourceConfigsMap(HARDWARE_SOURCE_CONFIGS_STR);

function getHardwareSourceConfigsMap(hardwareSourceConfigsStr: string): Map<string, HardwareSourceConfig> {
    return new Map<string, HardwareSourceConfig>(JSON.parse(hardwareSourceConfigsStr));
}
